@use '~/theme/theme' as *;

.container {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr;
  gap: spacing(1);
  align-items: center;
  max-height: 140px;
  overflow-y: auto;
  justify-content: space-between;
}
